import { Component } from '@angular/core';
import { NavParams, NavController } from 'ionic-angular';
import { OnPremiseProvider } from '../../providers/on-premise';
import { NavSidebarProvider } from '../../providers/nav-sidebar';

export enum LicenseStatus {
    Missing = 'Mssing',
    Expired = 'Expired',
    ExpiringSoon = 'ExpiringSoon'
}


@Component({
    selector: 'license-error-page',
    templateUrl: 'license-error-page.html'
})
export class LicenseErrorPage {
    public licenseStatus: LicenseStatus;
    public licenseExpirationDate: string;
    public LicenseStatus = LicenseStatus;

    constructor(
        public navParams: NavParams,
        private onPremiseProvider: OnPremiseProvider,
        private nav: NavController,
        private navSidebarProvider: NavSidebarProvider
    ) {
        this.licenseStatus = this.navParams.get('licenseStatus');
        this.licenseExpirationDate = this.navParams.get('licenseExpirationDate');
    }

    public forceHealthCheck() {
        this.onPremiseProvider.healthcheck();
    }

    public acknowledge() {
        this.nav.setRoot(`DashboardPage`);
    }

    public async ionViewDidEnter(): Promise<void> {
        this.navSidebarProvider.currentMetadata = {
            hasNavbar: false,
            projectIdentifier: undefined,
            datasetIdentifier: undefined,
            isSettingsPage: false
        };
    }
}



// WEBPACK FOOTER //
// ./src/pages/license-error-page/license-error-page.ts